/**
 * API do módulo Importação Brasíndice (Sabor B, ADR 0012), chamada direto do
 * navegador — MODULO_AURA.md §15 B.2. O AURA diz onde o módulo está
 * (GET /servicos/brasindice) e o JWT do usuário vai no Authorization, igual ao
 * `api` do AURA. O módulo valida o token com a mesma SECRET_KEY.
 */
import axios from 'axios';
import api from './api';

let cliente = null;
let servico = null;

export async function servicoBrasindice() {
  if (servico) return servico;
  const { data } = await api.get('/servicos/brasindice');
  servico = data;
  return servico;
}

export async function brasindice() {
  if (cliente) return cliente;
  const s = await servicoBrasindice();
  if (!s.configurado) throw new Error(s.aviso || 'Importação Brasíndice não configurada nesta instância.');
  cliente = axios.create({ baseURL: s.url, headers: { 'Content-Type': 'application/json' } });
  cliente.interceptors.request.use((config) => {
    let token = null;
    try { token = localStorage.getItem('token'); } catch (e) { /* sem storage */ }
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  cliente.interceptors.response.use(
    (r) => r,
    (err) => {
      const detail = err?.response?.data?.erro || err?.response?.data?.detail;
      if (err?.response?.status === 401) return Promise.reject(new Error('Sessão do AURA expirada para o módulo. Saia e entre de novo.'));
      if (!err?.response) return Promise.reject(new Error('O módulo Brasíndice não respondeu. Veja se ele está no ar.'));
      return Promise.reject(new Error(detail || `Erro ${err.response.status} no módulo Brasíndice.`));
    },
  );
  return cliente;
}

export const brasindiceAPI = {
  me: async () => (await (await brasindice()).get('/api/me')).data,
  painel: async () => (await (await brasindice()).get('/api/painel')).data,
  edicoes: async () => (await (await brasindice()).get('/api/edicoes')).data,
  importarEdicao: async (edicao) => (await (await brasindice()).post(`/api/cargas/${edicao}/importar-edicao`, {})).data,
  statusImportacao: async (edicao) => (await (await brasindice()).get(`/api/cargas/${edicao}/importar/status`, { params: { categoria: '*' } })).data,
  pesquisarItem: async (q) => (await (await brasindice()).get('/api/pesquisa/item', { params: { q } })).data,
  historicoSoul: async (tiss, tuss) => (await (await brasindice()).get('/api/pesquisa/item/soul', { params: { tiss, tuss: tuss || '' } })).data,
  historicoArquivo: async (categoria) => (await (await brasindice()).get(`/api/pesquisa/arquivo/${encodeURIComponent(categoria)}`)).data,
  agenda: async () => (await (await brasindice()).get('/api/agenda')).data,
  salvarAgenda: async (dados) => (await (await brasindice()).post('/api/agenda', dados)).data,
  disparar: async () => (await (await brasindice()).post('/api/agenda/disparar', {})).data,
  automacao: async () => (await (await brasindice()).get('/api/automacao')).data,
  // aba Dashboard
  analiseLista: async () => (await (await brasindice()).get('/api/analise')).data,
  analise: async (edicao, recalcular = false) => (await (await brasindice()).get(`/api/analise/${edicao}`, { params: recalcular ? { recalcular: 1 } : {} })).data,
  operacao: async () => (await (await brasindice()).get('/api/operacao')).data,
  alertas: async () => (await (await brasindice()).get('/api/alertas')).data,
  relatorioTiss: async (edicao) => {
    const r = await (await brasindice()).get(`/api/analise/${edicao}/relatorio-tiss.xlsx`, { responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement('a'); a.href = url; a.download = `tiss_divergencias_${edicao}.xlsx`; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  },
};
